import OfferConf from './OfferConf.vue'
import OfferList from './OfferList.vue'
import OfferPage from './OfferPage.vue'

export default {
  routers() {
    return [
      {
        path: '/offer',
        name: 'offerConf',
        component: OfferConf
      },
      {
        path: '/account/offers',
        name: 'offerList',
        component: OfferList
      },
      {
        path: '/account/offer/:offerId',
        name: 'offerPage',
        component: OfferPage,
        props: true
      },
    ];
  }
}



// WEBPACK FOOTER //
// ./src/components/offer/src/Router.js